import Reporte from "../../page/reportes/Reporte"


const ReporteController = () => {


    return (
        <Reporte />
    )
}

export default ReporteController